import { defineNuxtPlugin } from "nuxt/app";
import { useUserProfileStore } from "@/store/userProfileStore";
import { BEAMER_TRIGGER_CSS_CLASS } from "@/constants/shared";

export default defineNuxtPlugin(() => {
  const userProfileStore = useUserProfileStore();
  let initialized = false;

  const initializeBeamer = () => {
    if (initialized || !userProfileStore.showBeamer) {
      return;
    }

    const config = {
      product_id: userProfileStore.beamerKey,
      user_id: `${userProfileStore.customerId}-${userProfileStore.userId}`,
      userid: userProfileStore.userId,
      user_firstname: userProfileStore.firstName || "",
      user_lastname: userProfileStore.lastName || "",
      customerid: userProfileStore.customerId,
      button: false,
      selector: `.${BEAMER_TRIGGER_CSS_CLASS}`
    };

    const configScript = document.createElement("script");
    configScript.textContent = `var beamer_config = ${JSON.stringify(config)};`;

    const script = document.createElement("script");
    script.src = "https://app.getbeamer.com/js/beamer-embed.js";
    script.defer = true;

    document.head.appendChild(configScript);
    document.head.appendChild(script);
    initialized = true;
  };

  return {
    provide: {
      initializeBeamer
    }
  };
});